// extracted by mini-css-extract-plugin
module.exports = {"heading":"info_heading_1I_tf","list":"info_list_2VHlm","item":"info_item_jVWja","date":"info_date_2ItwA","title":"info_title_2mEYX"};